// @ts-strict-ignore
import {Location} from 'react-router';

import {BookmarkType} from 'common/report/queries/app-api/bookmark-client';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {onDemandAnalysisClient} from 'common/report/queries/app-api/on-demand-analysis-client';
import {RequestOdaDetail} from 'common/report/report-manager/types';
import type {MetricsResource} from 'common/report/model-resources/metrics';
import type {BehaviorsResource} from 'common/report/model-resources/behaviors';

import {FlowsReportManager} from '../flows/manager';
import {InsightsReportManager} from '../insights/manager';
import {DashboardBookmarkOverrides} from '../util/bookmark-overrides';
import {ReportManager, ReportManagerParams} from './index';

export const SUPPORTED_BOOKMARK_TYPES = [
  BookmarkType.Insights,
  BookmarkType.Funnels,
  BookmarkType.Flows,
  BookmarkType.Retention,
];

export function reportManagerFromType({
  bookmarkType,
  projectId,
  workspaceId,
  location,
  insightsReportMode,
  metricsResource,
  behaviorsResource,
  dashboardOverrides,
}: {
  bookmarkType: BookmarkType;
  projectId: number;
  workspaceId?: number;
  location: Location;
  insightsReportMode?: BookmarkType;
  metricsResource?: MetricsResource;
  behaviorsResource?: BehaviorsResource;
  dashboardOverrides?: DashboardBookmarkOverrides;
}): ReportManager | null {
  const managerParams: ReportManagerParams = {
    projectId,
    workspaceId,
    location,
    insightsReportMode,
    metricsResource,
    behaviorsResource,
    dashboardOverrides,
  };

  switch (bookmarkType) {
    case BookmarkType.Insights:
    case BookmarkType.Funnels:
    case BookmarkType.Retention:
      return new InsightsReportManager(managerParams);
    case BookmarkType.Flows:
      return new FlowsReportManager(managerParams);
    default:
      // not supported
      return null;
  }
}

export async function submitOdaRequest(
  info: RequestOdaDetail & {
    taskId: string;
    bookmarkType: BookmarkType;
    projectId: number;
    workspaceId: null | number;
    userId: number;
    projectAsOfDate: null | string;
    bookmarkParams: any;
    bookmarkId: null | number;
    hasUnsavedChanges: boolean;
  },
): Promise<void> {
  const dateRange = DateRange.fromBookmarkFormat(info.bookmarkDateRange);
  const {from: fromDate, to: toDate} = dateRange.getCalendarDatesAsOf(info.projectAsOfDate);
  const bookmarkId = info.bookmarkId ?? -1;

  const result = await onDemandAnalysisClient.query({
    bookmarkType: info.bookmarkType,
    projectId: info.projectId,
    fromDate,
    toDate,
    bookmark: JSON.stringify(info.bookmarkParams),
    bookmarkId,
    bookmarkUrl: info.bookmarkUrl,
    taskId: info.taskId,
    reportDirty: info.hasUnsavedChanges,
    workspaceId: info.workspaceId,
  });

  if (result.status === `error`) {
    throw new Error(result.error);
  }
}
